import * as mws from '../../../../shared/MwsViewModels';
import { Vue, Component, Prop } from 'vue-property-decorator';
import template from './usm-performance-and-portfolio-bar-chart.vue';

@Component({
  mixins: [template]
})
export default class UsmPerformanceAndPortfolioBarChart extends Vue {
    @Prop()
    chartData: mws.UsmPerformanceAndPortfolioBarChart;

    @Prop()
    tabIndex: number;

    @Prop() 
    itemIndex: number;
}